export default {"src":"/_next/static/media/memeSignal.d9ac5d03.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};